export default {
  use: [
    {
      Desc: "星星礼盒*1",
      ItemID: 12963,
      Honor: "5"
    },
    {
      Desc: "传送卷轴*1",
      ItemID: 12964,
      Honor: "10"
    },
    {
      Desc: "大加密箱*1",
      ItemID: 1056,
      Honor: "25"
    },
  ],
  bank: [
    {
      Desc: "50迷你币", Honor: 100, ItemID: 10002
    },
    {
      Desc: "300迷你币", Honor: 500, ItemID: 10002
    },
    {
      Desc: "1500迷你豆", Honor: 300, ItemID: 10000
    }
    
  ],
  dress: [
    {
      Desc: "悍马头饰", Honor: 50, ItemID: 21676
    },
    {
      Desc: "书包", Honor: 150, ItemID: 21620
    },
    {
      Desc: "宇航员背包", Honor: 200, ItemID: 21625
    }
  ],
  forever: [
    {Desc: "迷斯拉", Honor: 300, ItemID: 13024},
    {Desc: "雪灵", Honor: 200, ItemID: 20410},
    {Desc: "慕容笑天", Honor: 500, ItemID: 13033}
  ],
  collect: [
    {Desc: "叮叮当", Honor: 600, ItemID: 13030,Left: "???"},
    {Desc: "二郎神", Honor: 1000, ItemID: 20402,Left: "???"},
    {Desc: "齐天小圣", Honor: 3000, ItemID: 13022,Left: "???"}
  ],
  hot: [
    {
      Desc: "1500迷你豆", Honor: 300, ItemID: 10000
    },
    {
      Desc: "雪灵", Honor: 200, ItemID: 20410
    },
    {
      Desc: "叮叮当", Honor: 600, ItemID: 13030
    },
    {
      Desc: "齐天小圣", Honor: 3000, ItemID: 13022
    }
  ],
}


// WEBPACK FOOTER //
// ./src/components/goodsList.js